/**
 * One-time codes go to ONE channel, and which one is the server's answer.
 *
 * Since Sept 2026 the identifier names the channel: `{email}` sends an email and can only
 * verify the email, `{phone}` sends an SMS and can only verify the phone. The request
 * response reports it as `data.channel` (`'email' | 'sms'`).
 *
 * Every OTP screen used to infer the channel from its own tab state instead. That is
 * right today and right only by coincidence — the form and the server happen to agree
 * because the form is what chose the identifier. Reading the server's word costs nothing
 * and stays right if the backend ever decides differently.
 */

// The account has no usable contact on the channel that was asked for — a placeholder
// email, or no phone on file. There is no second channel quietly receiving the same code
// any more, so the only way forward is the other identifier.
export const OTP_CHANNEL_UNAVAILABLE = 'otp_channel_unavailable'

/**
 * "phone" / "email", for a sentence like "We sent a code to your ___".
 *
 * Prefers the server's `channel`; falls back to the local method for a screen reached
 * before the channel was captured (a reload, or a session that predates this build).
 */
export function channelNoun(channel, otpMethod) {
    if (channel === 'sms') return 'phone'
    if (channel === 'email') return 'email'
    return otpMethod === 'phone' ? 'phone' : 'email'
}

/** The OTHER identifier, for "try your ___ instead" when a channel is unavailable. */
export function otherChannelNoun(otpMethod) {
    return otpMethod === 'phone' ? 'email' : 'phone number'
}
